import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { IAuthenticationMethod, IOAuthOptionsFlow, IOAuthOptionsFlowProperty } from 'app/security/core/typings/IAuthentication';
import { Subject } from 'rxjs';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'biz-security-auth-list',
  templateUrl: './security-auth-list.component.html',
  styleUrls: ['./security-auth-list.component.scss']
})
export class SecurityAuthListComponent implements OnInit, OnChanges {
  @Input() methodType: string;
  @Input() selectedOption: | { key: string; value: string } | IOAuthOptionsFlowProperty;
  @Input() selectedMethod: IAuthenticationMethod;
  @Input() selectedMixedMethod: IAuthenticationMethod;
  @Input() selectedFlow: IOAuthOptionsFlow;
  @Input() selectedMetadata: { [key: string]: string };
  @Input() currentValue: string;
  @Input() currentFileName: string;
  @Input() showTitle = true;
  @Input() showSearchBox = false;
  @Input() isDisabled = false;

  @Output() onSelectOption = new EventEmitter();
  @Output() onSelectOAuthOption = new EventEmitter();
  @Output() onSetMixedOption = new EventEmitter();

  saveResponse$: Subject<boolean> = new Subject<boolean>();
  loadingAuthentication: boolean;
  currentAllowedExtensions: string;

  items: any;

  constructor(private translateService: TranslateService) {
  }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.selectedFlow || this.selectedMethod) {
      let items = null;
      if (this.selectedFlow)
        items = this.selectedFlow.properties;
      else
        items = Object.entries(this.selectedMethod['options']).map(([key, value]) => ({ key, value }));


      if (!_.isEmpty(this.selectedMetadata))
        items = items.filter(item => (item.key ? this.selectedMetadata[item.key] : this.selectedMetadata[item.name]) !== undefined);

      this.items = this.transform(items, 'AUTHENTICATION.OPTIONS_');
    }
  }

  transform(items: any[], parentTranslation: string, customProperty?: string, isUpperCase: boolean = false): any {
    if (!items) {
      return items;
    }

    if (items && items.length > 0 && items[0].type && items[0].type.toLowerCase() === 'parametricentities')
      return items;

    return _.orderBy(_.map(items, (newItem) => {
      const newItemWithTranslation = { ...newItem };
      this.translateService.get(parentTranslation +
        (newItem.key || newItem.name || (isUpperCase ? newItem[customProperty].toUpperCase() : newItem[customProperty])))
        .subscribe((res) => {
          newItemWithTranslation.translation = res;
        });
      return newItemWithTranslation;
    }), ['translation']);
  }

  setSelectOption(item) {
    this.onSelectOption.emit(item);
  }

  setSelectOAuthOption(item) {
    this.onSelectOAuthOption.emit(item);
  }

  mixedOption(option) {
    this.onSetMixedOption.emit(option);
  }

  setStyles(item) {
    return this.selectedOption && 'key' in item && item.key === this.selectedOption['key'];
  }
}
